export const SELECT_PCP_ID = 'selectPcpId';
export const SELECT_PLAN = 'selectPlan';
export const SELECT_MEMBER = 'selectMember';
export const SELECT_REASON = 'selectReason';
export const REVIEW_SELECTIONS = 'reviewSelections';
